import BaseEvent from './base_event';
import { CockroachesInvasion } from './invasion';
import * as ItemsFactory from '../../objects/items/items_factory';
import { Rarity } from '../../objects/items/base_item'
import GreenAlien from '../../objects/items/moveable/green_alien';


export default class LastChanceEvent extends BaseEvent {
    static canOccur(gameState) {
        let st = gameState.eventsResults.lastChance;
        if (!st) {
            st = gameState.eventsResults.lastChance = {
                left: 3,
                pants: true,
                occult: true,
                bucket: true
            }
        }
        return gameState.stoppedTime > 5000 
             && gameState.availableItemsOnShip().length < 2 
             && gameState.howMuchTimeToFly() === 0 
             && st.left > 0;

    }

    enter(gameState) {
        if (typeof ga === "function") ga('send', 'event', 'game', 'LastChanceEvent');

        let st = gameState.eventsResults.lastChance;
        let room = gameState.getRandomRoomWithoutHero();
        st.left--;
        let stupidHammer = gameState.has('hammer') && gameState.badKarma ? ", except that stupid hammer" : "";

        this.ui.showDialog({
            message: "You run out of energy, and it seems there's nothing left to burn" + stupidHammer + ". You think about it for a while and came up with a genious plan!",
            options: [{
                text: "Take off your pants and throw them into furnace",
                condition: st.pants,
                callback: () => {
                    st.pants = false;
                    gameState.appendEnergy(10);
                    game.narrator.shiftEventCloser();
                    gameState.hero.takeOffPants();
                    this.ui.showDialog({
                        message: "You quickly jump from your pants and throw them into the fiery stomach of the fusion furnace. Nice plan, pantless captain.",
                        status: " -dignity"
                    }, this.end)
                }
            }, {
                text: "Recall your internship on Mars and perform an occult ritual to summon some help",
                condition: st.occult,
                callback: () => {
                    gameState.stoppedTime = 0;
                    gameState.history.push({ id: 'last', msg: `performed occult rituals with a frightening rate of success` });
                    st.occult = false;
                    let dice = game.rnd.frac();
                    let item;
                    if (dice < 0.3) {
                        this.ui.showDialog({
                            message: "Good news: your call has been heard!\nBad news: they want to suck your brains through your nostrils.",
                            status: "Invasion!"
                        }, () => {
                            game.narrator.shiftEventCloser(GreenAlien.mass * 3);
                            this.schedule(CockroachesInvasion, 0);
                        });
                        return;
                    } else if (dice < 0.9) {
                        item = ItemsFactory.produceByRarity(room, Rarity.COMMON)[0];
                    } else {
                        item = ItemsFactory.produceByRarity(room, Rarity.RARE)[0];
                    }
                    gameState.items.add(item);
                    this.ui.showDialog({
                        message: "You draw the pentagram with your trusty conductive markers and wait for those who live on the Fractal Plane. One blinding flash of light after, you see the " + item.constructor.label + " before you. You appreciate the humor.",
                        status: "+ " + item.constructor.label
                    }, () => {
                        game.narrator.shiftEventCloser(item.constructor.mass);
                        this.end();
                    })
                }
            }, {
                text: "Press the emergency button!",
                condition: st.bucket,
                callback: () => {
                    gameState.stoppedTime = 0;
                    this.ui.showDialog({
                        message: "Emergency proton trap deployed, says the ship, and drops a lead bucket on a rope from the airlock. You gaze upon the marvels of technology for a while and get to work.",
                        status: ""
                    }, () => {
                        st.bucket = false;
                        this.ui.showMinigame("Use left/right to move\nUse space to catch", Minigame, (catched) => {
                            if (catched) {
                                gameState.history.push({ id: 'last', msg: `catched protons in a bucket ${gameState.eventsResults.lastChance.pants ? "" : "with his pants off"}` });
                                this.ui.showDialog({
                                    message: "You drop a full bucket of protons into a furnace. Then you think it might have been better to EMPTY the bucket into a furnace. Then you do a facepalm.",
                                    status: "+" + catched + "% energy\n-emergency proton trap"
                                }, () => {
                                    this.gameState.appendEnergy(catched);
                                    game.narrator.shiftEventCloser();
                                    this.end();
                                })
                            } else {
                                gameState.history.push({ id: 'last', msg: `failed the bucket challenge` });
                                this.ui.showDialog({
                                    message: "In a hopeless attempt to catch a single proton you cast the bucket too far, and it breaks the rope. Aw, snap.",
                                    status: "-emergency proton trap"
                                }, this.end)
                            }
                        })
                    })
                }
            }]
        })
    }
}


class Minigame {
    constructor(x, y, stopCb) {
        if (typeof ga === "function") ga('send', 'event', 'game', 'LastChanceGame');

        this.bitmap = game.add.bitmapData(400, 300);
        this.sprite = game.add.sprite(x + 350, y - 150, this.bitmap);
        this.stopCb = stopCb;
        this.particles = [];
        for (let i = 0; i < 100; i++) {
            this.particles.push({ x: game.rnd.integerInRange(2, 390), y: game.rnd.integerInRange(100, 190) });
        }
        this.bucket = {
            x: 200, y: 10, go: "down"
        };
        this.collected = {
            photons: 0,
            attempts: 5
        };
        this.redraw();
    }

    updateInput(cursors, keys) {
        if (keys.space.justDown && !this.bucket.go) {
            this.bucket.go = "up";
        }
        if (cursors.left.isDown && !this.bucket.go && this.bucket.x > 2) {
            this.bucket.x -= 2;
        }
        if (cursors.right.isDown && !this.bucket.go && this.bucket.x < 397) {
            this.bucket.x += 2;
        }

        this.update();

        this.redraw();

        if (this.collected.attempts <= 0) {
            this.stopCb(this.collected.photons);
        }
    }

    update() {
        if (this.bucket.go === "down") {
            this.bucket.y += 20;
            if (this.bucket.y > 220) {
                this.bucket.y = 220;
                this.bucket.go = null;
            }
        }
        if (this.bucket.go === "up") {
            this.bucket.y -= 2;
            for (let p of this.particles) {
                if (p.x >= this.bucket.x - 10 + 2 && p.x <= this.bucket.x + 10 - 9 - 2 && p.y >= this.bucket.y + 10 + 2 && p.y <= this.bucket.y + 40 - 9 - 2) {
                    p.locked = true;
                }
                if (p.locked) {
                    p.y -= 2;
                }
            }

            if (this.bucket.y <= 10) {
                this.bucket.y = 10;
                this.bucket.go = "down";
                this.collected.attempts--;
                for (let p of this.particles) {
                    if (p.locked) {
                        this.collected.photons++;
                    }
                }
                this.particles = this.particles.filter(p => !p.locked);
            }
        }

        for (let p of this.particles) {
            if (p.locked) {
                continue;
            }
            while (p.dx === undefined || p.dy === undefined || (p.x + p.dx < 2) || (p.x + p.dx > 390) || (p.y + p.dy < 100) || (p.y + p.dy > 190)) {
                p.dx = game.rnd.pick([-2, -1, 1, 2]);
                p.dy = game.rnd.pick([-2, -1, 1, 2]);
            }
            p.x += p.dx;
            p.y += p.dy;
        }
    }

    redraw() {
        let ctx = this.bitmap.ctx;
        this.bitmap.clear();
        ctx.fillStyle = "#3C556B";
        ctx.fillRect(3, 0, this.bucket.x - 10, 10);
        ctx.fillRect(this.bucket.x + 10, 0, 400, 10);

        ctx.strokeStyle = "gray";
        ctx.lineWidth = 3;
        ctx.strokeRect(2, 2, this.bitmap.width - 2, this.bitmap.height - 2);
        for (let p of this.particles) {
            ctx.fillStyle = "#94181F";
            ctx.fillRect(p.x, p.y, 9, 9);
        }
        ctx.strokeStyle = "gray";
        ctx.beginPath();
        ctx.moveTo(this.bucket.x, 1);
        ctx.lineTo(this.bucket.x, this.bucket.y);
        ctx.lineTo(this.bucket.x - 10, this.bucket.y + 10);
        ctx.moveTo(this.bucket.x, this.bucket.y);
        ctx.lineTo(this.bucket.x + 10, this.bucket.y + 10);
        ctx.stroke();
        ctx.strokeStyle = "#3C556B";
        ctx.beginPath();
        ctx.moveTo(this.bucket.x - 10, this.bucket.y + 10);
        ctx.lineTo(this.bucket.x - 10, this.bucket.y + 40);
        ctx.lineTo(this.bucket.x + 10, this.bucket.y + 40);
        ctx.lineTo(this.bucket.x + 10, this.bucket.y + 10);
        ctx.stroke();
        ctx.strokeStyle = "gray";
        ctx.lineWidth = 1;
        ctx.font = "12px monospace";
        ctx.strokeText("collected", 290 - 90, 24);
        ctx.strokeText("attempts", 5, 24);
        ctx.strokeText(this.collected.attempts, 70, 24);
        ctx.strokeStyle = "#94181F";
        ctx.strokeText("+" + this.collected.photons + "% energy", 360 - 90, 24);

        this.bitmap.dirty = true;
    }

}



// WEBPACK FOOTER //
// ./src/states/events/last_chance_event.js